// extracted by mini-css-extract-plugin
export default {"scrollButton":"Home_scrollButton__Gzcev"};